var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison-text"},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"field-wrapper"},[_c('input',{staticClass:"field",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.initialValue}}),_vm._t("mark")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }